// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".674e1bf9dfc0099d55eb8835cdd6bf9f.js";
};